module.exports = __webpack_public_path__ + "static/media/logo.df60c27e.webp";